import * as React from 'react';
import { Card as FlowBiteCard, CardProps as FlowBiteCardProps } from 'flowbite-react';
import clsx from 'clsx';
import { cardTheme } from '../../styles/themes/card';

export type CardType = 'filled' | 'outline' | 'ghost';

export type CardProps = FlowBiteCardProps & {
    variant?: CardType;
    style?: string;
};

const getVariantClasses = (variant: CardType): string => {
    switch (variant) {
        case 'outline':
            return 'border border-solid border-system-outline-variant bg-system-surface';
        case 'ghost':
            return 'bg-system-surface';
        case 'filled':
        default:
            return 'bg-system-surface-container';
    }
};

export const Card: React.FC<CardProps> = ({ variant = 'filled', className, style, ...props }) => {
    const variantClass = getVariantClasses(variant);

    return <FlowBiteCard className={clsx(variantClass, className, style)} theme={cardTheme} {...props} />;
};
